




















































































import BraintreeDropin from 'braintree-web-drop-in';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { ClientSubscription, ClientSubscriptionStatus } from '@/models/payment/PaymentMethods';
import SubscriptionPlan from '@/models/payment/SubscriptionPlan';
import Coupon from '@/models/payment/Coupon';
import User from '@/models/User';
import DropinContainer from './DropinContainer.vue';
import PaymentMethodManager from './PaymentMethodManager.vue';
import PaymentPlanComponent from './PaymentPlan.vue';
import PaymentMethodSelect from './SubPanelPaymentMethods.vue';
import CenteredSpinner from '@/components/CenteredSpinner.vue';

@Component({
    refs: ['dropinContainer'],
    components:
    {
        PaymentPlanComponent,
        DropinContainer,
        PaymentMethodSelect,
        PaymentMethodManager,
        CenteredSpinner,
    },
    recomputed: {
        paymentMethodReady()
        {
            const _this = this as LTIPaymentPanel;
            if (_this.dropin)
            {
                return _this.dropin.isPaymentMethodRequestable();
            }
            return false;
        }
    }
})
export default class LTIPaymentPanel extends Vue
{
    @Prop(String) readonly pid! : String;

    busy = false;
    price = -1;
    enteredPaywallCode = '';
    message: string | null = null;
    currentStep = -1;
    paymentMethod : BraintreeDropin.PaymentMethodPayload | null = null;

    get displayPrice()
    {
        return `$${this.price.toFixed(2)}`;
    }

    get dropinContainer() : DropinContainer | null
    {
        if (!this.$refs.dropinContainer) return null;
        return this.$refs.dropinContainer as (DropinContainer);
    }

    get dropin() : BraintreeDropin.Dropin | null | undefined
    {
        if (!this.dropinContainer) return null;
        return this.dropinContainer.dropin;
    }

    async submitPaywallCode()
    {
        if (this.busy) return;

        this.busy = true;
        try
        {
            await this.$http.post('payments/lti/activate-code', { pid: this.pid, code: this.enteredPaywallCode });
            await this.loadData();
            this.$router.push(`/app/reconnect/${this.pid}`);
        }
        catch(err)
        {
            if (err.response && err.response.data && err.response.data.error)
            {
                alert(err.response.data.error);
            }
            else
            {
                alert('Invalid code, please try again.');
            }
            
            console.error(err);
        }
        this.busy = false;
    }

    async confirmPayment()
    {
        if (this.busy) return;

        this.busy = true;
        try
        {
            const data = {
                pid: this.pid,
                nonce: this.paymentMethod ? this.paymentMethod.nonce : undefined,
                coupon: undefined
            };

            if (!data.nonce)
            {
                alert('Invalid payment method, please try another.');
                this.goToChangePaymentMethodView();
                return;
            }

            await this.$http.post('payments/lti/purchase', data);
            this.$emit('payment-complete', this.pid);
        }
        catch(er)
        {
            console.error(er);
        }
        this.busy = false;
    }

    goToChangePaymentMethodView()
    {
        this.currentStep = 1;
        this.$set(this, 'paymentMethod', null);
    }

    async selectPaymentMethod() : Promise<any>
    {
        const dropin = this.dropin;
        if (!dropin) return;

        const method = await dropin.requestPaymentMethod();
        this.$set(this, 'paymentMethod', method);
        if (this.paymentMethod)
        {
            this.currentStep = 2;
        }
        return method;
    }

    async loadData()
    {
        this.busy = true;
        try
        {
            const resp = (await this.$http.get<{price: number, message: string | null}>(`payments/lti/price?pid=${this.pid}`));
            const { price, message } = resp.data;
            this.price = price;
            this.message = message;
        }
        catch(er)
        {
            console.error(er);
        }
        this.busy = false;
    }

    onMethodChange()
    {
        this.$recompute('paymentMethodReady');
    }

    async mounted()
    {
        await this.loadData();
        this.currentStep = 0;
    }
}
